module.exports = __webpack_public_path__ + "static/media/galerija_2013 (4).211975af.jpg";